import { observable, action, computed } from 'mobx';
import { store } from '../store.index';
// import { Modal } from 'antd';
import FileSaver from 'file-saver';
// const { confirm } = Modal;
import getStream from './getStream';
import utils from '@foxit/utils';
import { getUserInfo } from '../../api/fwApi/login';

// !该store用于保存文件时的操作
class saveFileNewStore extends getStream {
  // !保存文件时的弹框提示内容，区分企业非企业
  @observable file = null;
  @observable saveType = 'downFile';
  @observable showDialog = false;
  @observable showSaveDialog = false;
  @observable isShowFwDocsIframe = false;
  @observable isShowFwDocs = false;
  @observable isSaveSuccess = false;

  @action setIsSaveSuccess(val) {
    this.isSaveSuccess = val;
  }
  @action setShowSaveDialog(val) {
    this.showSaveDialog = val;
  }

  @action setShowDialog(showDialog, userInfo) {
    if (showDialog) {
      //! 若非会员，这里需要从新获取用户信息判断下是否会员，处理用户开通完了回来依旧弹窗
      if (userInfo) {
        if (userInfo.identity === 'vip') {
          this.getFileBlob().then((blob) => {
            store.appStore.doUpdateDocModified(false);
            store.addCoverPageStore.uploadFile(blob);
          });
        } else {
          this.showDialog = showDialog;
        }
      } else {
        //! 没有携带用户信息的重新从接口获取信息，判断是否会员
        const config = {
          headers: {
            client: 'editCloud',
          },
          params: {
            token: utils.util.getQueryString('token'),
          },
        };
        getUserInfo(config).then((res) => {
          if (res.ret === 0) {
            store.userNewStore.setUserInfo(res.data);
            if (res.data.identity === 'vip') {
              this.getFileBlob().then((blob) => {
                store.appStore.doUpdateDocModified(false);
                store.addCoverPageStore.uploadFile(blob);
              });
            } else {
              this.showDialog = showDialog;
            }
          }
        });
      }
    } else {
      this.showDialog = showDialog;
    }
  }
  @action setSaveType(saveType) {
    this.saveType = saveType;
  }
  @action setIsShowFwDocsIframe(isShowFwDocsIframe) {
    this.isShowFwDocsIframe = isShowFwDocsIframe;
  }
  @action setIsShowFwDocs(isShowFwDocs) {
    this.isShowFwDocs = isShowFwDocs;
  }

  @computed get message() {
    const { isBusinessUser } = store.userNewStore;
    return isBusinessUser
      ? '您还不是福昕会员，在保存文档时，将会被添加一页封面页。开通福昕会员，享受福昕云编辑全部功能。'
      : '您不是福昕云办公会员，在保存文档时，将会被添加一页封面页。现在升级为福昕云办公会员，享受福昕云编辑全部功能使用权。';
  }
  // !保存文件
  @action saveFile(saveType, docModified) {
    console.log(docModified);
    this.setSaveType(saveType);
    // !区分是否会员
    const config = {
      headers: {
        client: 'editCloud',
      },
      params: {
        token: utils.util.getQueryString('token'),
      },
    };
    getUserInfo(config).then((res) => {
      if (res.ret === 0) {
        if (res.data.identity === 'vip') {
          store.appStore.doUpdateDocModified(false);
          store.common.setIsShowMeeting(false);
          this.isSaveSuccess = true;
          this.saveFileStream(saveType);
        } else {
          //编辑后才添加封面页
          // store.appStore.docModified, online中文档是否修改
          if (docModified || store.appStore.docModified || store.common.docModifiedNoSave) {
            // store.appStore.docModified会因为异步关系可能被置为false。修改后重新打开文件前，会把docModified置为false，但却不重新打开文件，导致非Vip可保存
            this.saveFileDialog(saveType, res.data);
          } else {
            this.saveFileStream(saveType);
            store.appStore.doUpdateDocModified(false);
          }
        }
      }
    });
  }
  // !保存/下载文件流
  @action async saveFileStream(saveType) {
    const pdfDoc = await window.pdfui.getCurrentPDFDoc();
    store.appStore.doUpdateDocModified(false);
    // !getFileBlob 新建一个方法类来处理
    this.getFileBlob().then((blob) => {
      if (saveType === 'cloudDoc') {
        new uploadFile().uploadDocument(blob);
      } else {
        // 处理ios手机端的vip保存 调用 download-file-button handle（）
        if (store.fwMobileViewStore.isIOS) {
          window.pdfui.getComponentByName('download-file-button').then((compByName) => {
            compByName.controller.handle();
          });
          return;
        }
        const fileName = store.addCoverPageStore.fileNameToPDF(pdfDoc.info.fileName);
        FileSaver(blob, fileName);
      }
    });
  }
  // !saveFileDialog 保存文件弹框
  @action saveFileDialog(saveType, userInfo) {
    this.setSaveType(saveType);
    this.setShowDialog(true, userInfo);
  }
}

export default saveFileNewStore;
